import { EnterViceApiError } from '../../../services/enterviceApi';

export interface UiError {
  message: string;
  type?: string;
  reasons?: string[];
}

/** Normalises anything thrown by the ENTER VICE service into something the screens can render. */
export const describeError = (error: unknown, fallback = 'Something went wrong. Please try again.'): UiError => {
  if (error instanceof EnterViceApiError) {
    return { message: error.message || fallback, type: error.type, reasons: error.reasons };
  }
  if (error instanceof Error) {
    return { message: error.message || fallback };
  }
  return { message: fallback };
};
